<template>
    <div class="dossier flex-row align-items-center gap-sm">
        <avatar-component :customer-id="customer.id"></avatar-component>

        <div class="flex-stretch mr-xxs">
          <p class="font-size-md mb-xxs color-primary font-regular">
              {{ fullName }}
          </p>

          <div v-if="customer.product_labels.data.length > 0" class="flex-row align-items-center flex-wrap mb-xxs gap-xxs">
              <span
                v-for="(label, key) in customer.product_labels.data"
                :key="key"
                class="label"
                :style="{backgroundColor: label.color}"
              >
                {{label.tag}}
              </span>
          </div>

          <p class="font-size-sm mb-0" v-if="customer.birthday">
            {{ customer.birthday }} (&hairsp;{{customer.age}}&hairsp;)
          </p>

          <div class="flex-row align-items-center flex-wrap mb-xxs gap-xxs">
            <span v-if="customer.type === customerTypeEnum.LEAD" class="label label-danger">LEAD</span>
            <span v-if="customer.type === customerTypeEnum.MORTGAGE_LEAD" class="label label-danger">Hypotheek LEAD</span>
            <span v-if="customer.type === customerTypeEnum.INSURANCE_LEAD" class="label label-danger">Verzekering LEAD</span>
          </div>
        </div>
    </div>
</template>

<script>
import CustomerUtil from "~/util/customer";
import customerTypeEnum from "~/enums/CustomerTypeEnum.js";
import AvatarComponent from "~/modules/customer/components/AvatarComponent.vue";

export default {
  name: "CustomerCell.vue",
  components: { AvatarComponent },
  props: {
    cellProps: {
      type: Object,
      required: true
    }
  },
  computed:{
    customerTypeEnum(){
        return customerTypeEnum;
    },
    customer(){
      return this.cellProps;
    },
    fullName: function () {
      if ( !this.customer ) return ''
      return CustomerUtil.getFullName(this.customer);
    },
  }
}
</script>
